// extracted by mini-css-extract-plugin
export default {"backForwardContainer":"ChartSlider_backForwardContainer__LYakb"};